var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooerSectionTwitterBgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5704 9.81077L16.3059 4.30615H15.1837L11.0719 9.08573L7.78782 4.30615H4L8.9662 11.5337L4 17.3062H5.12222L9.46441 12.2588L12.9327 17.3062H16.7205L11.5701 9.81077H11.5704ZM10.0334 11.5974L9.53019 10.8777L5.52657 5.15094H7.25024L10.4812 9.77261L10.9844 10.4923L15.1843 16.4998H13.4606L10.0334 11.5977V11.5974Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooerSectionTwitterBgWhite);
export default __webpack_public_path__ + "static/media/fooer_section_twitter_bg_white.342a169b89d430037775277e865396d8.svg";
export { ForwardRef as ReactComponent };